import { Button } from '@mui/material'
import Typography from '@mui/material/Typography'
import { format as dateFnsFormat } from 'date-fns/format'
import { ru } from 'date-fns/locale'
import { ModalDialogWrapper } from '../../components/ModalDialogWrapper'
import { useProfileStore } from '../../store/storeProfile'

export const StorageCancelDialog = ({ storage, open, handleClose, handleSubmit }) => {
    const { isLoadingCreateStorageTariffUser } = useProfileStore((state) => state)
    return (
        <ModalDialogWrapper
            footerActions={
                <>
                    <Button
                        variant="outlined"
                        fullWidth
                        onClick={handleSubmit}
                        disabled={isLoadingCreateStorageTariffUser}>
                        Отменить
                    </Button>
                    <Button variant="contained" onClick={handleClose} fullWidth>
                        Не отменять
                    </Button>
                </>
            }
            colorSubmitButton="secondary"
            variantCloseButton="contained"
            open={open}
            handleClose={handleClose}
            title={`Точно отменить подписку «${storage.storage_tariff.name}»?`}>
            <Typography variant="body2">
                Подписка будет активна до{' '}
                {dateFnsFormat(storage.end_at, 'd MMMM yyyy', {
                    locale: ru,
                })}
                . После этой даты продление не произойдёт
            </Typography>
        </ModalDialogWrapper>
    )
}
